// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root',
// })
// export class AuthService {
//   isAuth: boolean = false;

//   constructor() {}

//   signIn() {
  
//     this.isAuth = true;
//     return this.isAuth;
//   }

//   signOut() {
//     this.isAuth = false;
//     return this.isAuth;
//   }
// }
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user.model';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _currentUserSubject: BehaviorSubject<User>; 
  public currentUser: Observable<User>;

  constructor(private _client: HttpClient, private _router: Router) {
 
    this._currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
  
    this.currentUser = this._currentUserSubject.asObservable();
  }

  public get curentUserValue(): User {
    return this._currentUserSubject.value;
  }

  signIn(email: string, psd: string) {
    return (
      this._client
        .post<any>(`${environment.apiUrl}/user/1`, { email, psd})
    
        .pipe(
          map((user) => {
            localStorage.setItem('currentUser', JSON.stringify(user));
            this._currentUserSubject.next(user);

            return user;
          })
        )
    );
  }
  signOut() {
    // je retire l'utilisateur de localstroage
    localStorage.removeItem('currentUser');
    this._currentUserSubject.next(null);
    this._router.navigate(['home']);
  }
}




